import React, { useMemo, useState } from 'react';
import { Text } from '@/components/Text';
import { textVariantsEnum, fontWeightEnum } from '@/components/Text';
import styles from './Subscription.module.scss';
import { Button, buttonVariants } from '@/components/Button';
import { Input } from '@/components/Input';
import { useSelector } from 'react-redux';
const getUnitAmount = (plan, billingCycle, currencyCode) => {
  if (!plan?.pricing) return null;
  const pricing = plan.pricing[currencyCode] || plan.pricing.USD || {};
  switch (billingCycle) {
    case 'quarterly':
      return pricing.quarterly;
    case 'yearly':
      return pricing.yearly;
    default:
      return pricing.monthly;
  }
};

export const CheckoutSeatsPlanModal = ({
  subscriptionData,
  plan,
  onClose,
  billingCycle,
  currency,
  onConfirm,
}) => {
  const profile = useSelector((state) => state.auth?.profile);
  const [totalSeats, setTotalSeats] = useState('');
  const [error, setError] = useState(null);
  const amount = getUnitAmount(plan, billingCycle, currency);
  const seats = useMemo(() => {
    const q = subscriptionData?.occupiedSeats;
    if (q == null || q === '') return 2;
    const n = Number(q);
    return Number.isFinite(n) && n > 0 ? n : 2;
  }, [subscriptionData]);

  const unitNum = amount != null ? Number(amount) : NaN;
  const totalAmount =
    Number.isFinite(unitNum) && seats > 0
      ? unitNum * (Number(totalSeats) || seats)
      : null;

  const currencySymbol = currency === 'INR' ? '₹' : '$';
  const onConfirmClick = async () => {
    if (!totalSeats) {
      setError('Total seats is required');
      return;
    }
    if (totalSeats < 2) {
      setError('Minimum 2 seats are required');
      return;
    }
    if (totalSeats < seats) {
      setError('Total seats must be greater than or equal to current seats');
      return;
    } else {
      setError(null);
      onConfirm(Number(totalSeats));
    }
  };

  return (
    <div className={styles.checkoutSeatsPlanModal}>
      <Text
        variant={textVariantsEnum.Text_xl}
        fontWeight={fontWeightEnum.Medium}
      >
        Total Amount For Subscription
      </Text>
      <Text
        variant={textVariantsEnum.Text_md}
        fontWeight={fontWeightEnum.Normal}
      >
        Current Seats : {seats}
      </Text>
      <Input
        type="number"
        label="Total Seats"
        value={totalSeats}
        onChange={(e) => setTotalSeats(e.target.value)}
        errorMessage={error}
      />
      <Text
        variant={textVariantsEnum.Text_lg}
        fontWeight={fontWeightEnum.Medium}
      >
        {totalAmount != null ? (
          <>
            Total : {currencySymbol}
            {totalAmount.toFixed(2)}{' '}
            <span className={styles.checkoutSeatsPlanModalBreakdown}>
              ({currencySymbol}
              {Number.isFinite(unitNum) ? unitNum.toFixed(2) : '—'} ×{' '}
              {Number(totalSeats) || seats} seat{seats !== 1 ? 's' : ''})
            </span>
          </>
        ) : (
          'Price unavailable for this selection.'
        )}
      </Text>
      <div className={styles.buttonsContainer}>
        <Button
          variant={buttonVariants.secondary}
          text="Cancel"
          onClick={onClose}
        />
        <Button
          variant={buttonVariants.primary}
          text="Proceed to pay"
          onClick={onConfirmClick}
        />
      </div>
    </div>
  );
};
